import React, { Component } from 'react';
import Draggable, {
  DraggableData,
  DraggableEventHandler,
} from 'react-draggable';
import 'styled-components/macro';
import * as types from 'styled-components/cssprop'; /* eslint-disable-line */
import { RootDispatch, RootState } from '../../models/configure_store';
import { css, withTheme, Theme } from 'styled-components';
import { connect } from 'react-redux';
import TrackImage from '../TrackImage';
import VerifyMessage from '../verify-message';
import { getCaptchaDomains } from '../../service/captcha';
import { scale, isMobile } from '@/utils/constants';
import { baseRem } from '@/utils/rem';
// import Loading from '../Loading';
import * as logger from '../../utils/logger';

const mapState = ({ captcha }: RootState) => {
  const {
    selected_pos,
    question_url,
    answer_url,
    verify_status,
    loading,
    drag_pos,
    mode,
    verify_result_msg,
    show_verify_msg,
    point_add_able,
    challenge_code,
    challenge_id,
    challenge_mode,
    uuid,
    isFetch,
    backup_url1,
    backup_url2,
    backup_url1Index,
    backup_url2Index,
  } = captcha;
  return {
    drag_pos,
    answer_url,
    selected_pos,
    question_url,
    verify_status,
    loading,
    mode,
    verify_result_msg,
    show_verify_msg,
    point_add_able,
    challenge_code,
    challenge_id,
    challenge_mode,
    uuid,
    isFetch,
    backup_url1,
    backup_url2,
    backup_url1Index,
    backup_url2Index,
  };
};
const mapDispatch = ({ captcha }: RootDispatch) => {
  return {
    addPos: captcha.addPos,
    removePos: captcha.removePos,
    update: captcha.update,
  };
};
type VerifyImageProps = ReturnType<typeof mapState> &
  ReturnType<typeof mapDispatch> & {
    onDrag: (e: any, d: DraggableData) => void;
    onSubmit: () => void;
    onEnterSlide: (e: any) => void; // 因为 e 是 合成的，不能使用 Event
    onStart: (
      e: any,
      d: DraggableData,
      dragType: 'img' | 'btn' | 'none'
    ) => void;
    sliding: boolean;
    slide_btn_able: boolean;
    drag_type: 'img' | 'btn' | 'none';
    onMouseMove: () => void;
    img_error_text: string;
    imgLoadingBgColor: string;
    theme: Theme;
  };
interface VerifyImageState {
  loadAnswerSuccess?: boolean; // 是否加载地图成功
  loadQuestionSuccess?: boolean; // 是否加载拼图成功
  loadAnswerFailed?: boolean; // 是否加载地图失败
  loadQuestionFailed?: boolean; // 是否加载拼图失败
}

class VerifyImage extends Component<VerifyImageProps, VerifyImageState> {
  start_time: number = Date.now();
  $canvas!: HTMLDivElement;
  domainQuestionIndex: number = 0; // 验证码大图循环调度第几个domains域名
  domainAnswerIndex: number = 0; // 验证码拼图第几个domains域名

  constructor(props: Readonly<VerifyImageProps>) {
    super(props);
    this.state = {
      loadAnswerSuccess: false, // 是否加载地图成功
      loadQuestionSuccess: false, // 是否加载拼图成功
      loadAnswerFailed: false, // 是否加载地图失败
      loadQuestionFailed: false, // 是否加载拼图失败
    };
  }

  scheduleStatus: 'none' | 'pending' | 'end' = 'none'; // 大图的调度状态，用于埋点上报标识调度状态

  componentWillReceiveProps = (nextProps: any) => {
    // uuid变化说明重新了验证码，需要对数据初始化状态
    if (nextProps.uuid !== this.props.uuid) {
      this.setState({
        loadAnswerSuccess: false,
        loadQuestionSuccess: false,
        loadAnswerFailed: false,
        loadQuestionFailed: false,
      });
      this.scheduleStatus = 'none';
    }
    if (nextProps.question_url !== this.props.question_url) {
      this.setState({
        loadQuestionSuccess: false,
        loadQuestionFailed: false,
      });
      this.scheduleStatus = 'none';
    }
    if (nextProps.answer_url !== this.props.answer_url) {
      this.setState({
        loadAnswerSuccess: false,
        loadAnswerFailed: false,
      });
    }
    this.start_time = Date.now();
  };
  /**
   * 文字或3D点选验证码 - 收集点选坐标
   */
  handleCanvasClick = (e: any) => {
    const { mode } = this.props;
    if (mode === 'slide') {
      return;
    }
    // 收集点选坐标
    const { point_add_able } = this.props;
    if (!point_add_able) {
      return;
    }
    const pos = this.getTouchPos(e);
    this.props.addPos(pos);
  };
  /**
   * 文字或3D点选验证码 - 处理已选点的点击逻辑
   */
  handlePointClick = (idx: number) => {
    this.props.removePos(idx);
  };
  /**
   * 文字或3D点选验证码 - 获取用户点选位置
   */
  getTouchPos = (event: React.MouseEvent<HTMLCanvasElement>) => {
    const e = event;
    const $imgCanvasRect = this.$canvas.getBoundingClientRect();
    const $imgCanvasLeft = $imgCanvasRect.left;
    const $imgCanvasTop = $imgCanvasRect.top;
    const x = e.clientX - $imgCanvasLeft; // 点击坐标相对于视口的x轴的距离 - 图片相对于视口的x轴的距离=点击的位置在图片中的x轴的位置
    const y = e.clientY - $imgCanvasTop; // 点击坐标相对于视口的y轴的距离 - 图片相对于视口的y轴的距离=点击的位置在图片中的y轴的位置
    return { x: x, y: y, time: Date.now() };
  };
  // 文字或3D点选验证码 - 生成远点
  renderPoints = () => {
    const { selected_pos, theme } = this.props;
    const doms = selected_pos.map((item: Point, idx: number) => {
      return (
        <div
          className="verify-captcha-point"
          key={idx}
          css={css`
            position: absolute;
            z-index: 9999;
            display: flex;
            justify-content: center;
            align-items: center;
            width: 0.24em;
            height: 0.24em;
            line-height: 0.24em;
            border-radius: 50%;
            color: ${theme.dotColor};
            border: 1px solid ${theme.dotBorderColor};
            background-color: ${theme.dotBgColor};
            opacity: 0.8;
            filter: alpha(opacity=80);
            transform: translate(-50%, -50%);
            transition: left 0.3s cubic-bezier(0.42, 0, 0.58, 1),
              top 0.3s cubic-bezier(0.42, 0, 0.58, 1);
          `}
          style={{
            top: item.y,
            left: item.x,
          }}
          onClick={() => this.handlePointClick(idx)}
        >
          <span
            css={css`
              font-size: 0.14em !important;
            `}
          >
            {idx + 1}
          </span>
        </div>
      );
    });
    return doms;
  };
  // 背景图片加载错误调度处理
  imgErrorHandlerQuestion = async () => {
    const {
      update,
      img_error_text,
      question_url,
      backup_url1,
      backup_url1Index,
    } = this.props;
    this.setState(
      {
        loadQuestionFailed: true,
      },
      async () => {
        if (backup_url1Index >= 0) {
          update({
            question_url: backup_url1[backup_url1Index],
            backup_url1Index: backup_url1Index - 1,
          });
          this.scheduleStatus = backup_url1Index - 1 < 0 ? 'end' : 'pending';
          return;
        }
        if (question_url.trim()) {
          // 提示刷新
          update({
            show_verify_msg: true,
            verify_result_msg: img_error_text,
            isFetch: false,
            refresh_btn_able: true,
            loading: false,
          });
        }
      }
    );
    this.imgLoadLog({
      is_success: 0,
      img1: question_url,
      scheduleStatus: backup_url1Index >= 0 ? 'pending' : 'end',
    });
  };
  // 滑块图片加载错误调度处理
  imgErrorHandlerAnswer = async () => {
    const {
      update,
      img_error_text,
      answer_url,
      backup_url2,
      backup_url2Index,
    } = this.props;
    this.setState(
      {
        loadAnswerFailed: true,
      },
      async () => {
        if (backup_url2Index >= 0) {
          update({
            answer_url: backup_url2[backup_url2Index],
            backup_url2Index: backup_url2Index - 1,
          });
          return;
        }
        if (answer_url.trim()) {
          // 提示刷新
          update({
            show_verify_msg: true,
            verify_result_msg: img_error_text,
            isFetch: false,
            refresh_btn_able: true,
            loading: false,
          });
        }
      }
    );
    this.imgLoadLog({
      is_success: 0,
      img2: answer_url,
    });
  };
  // 图片加载成功处理
  onImgLoad = (type: 'loadAnswerSuccess' | 'loadQuestionSuccess') => {
    const { mode, update, question_url, answer_url } = this.props;
    this.setState(
      {
        [type]: true,
      },
      () => {
        if (mode === 'slide') {
          if (this.state.loadAnswerSuccess && this.state.loadQuestionSuccess) {
            update({
              isFetch: false,
              show_verify_msg: false,
              point_add_able: true,
              slide_btn_able: true,
              refresh_btn_able: true,
            });
            this.imgLoadLog({
              img1: question_url,
              img2: answer_url,
              is_success: 1,
            });
          }
        } else {
          update({
            isFetch: false,
            show_verify_msg: false,
            point_add_able: true,
            slide_btn_able: true,
            refresh_btn_able: true,
          });
          this.imgLoadLog({
            img1: question_url,
            is_success: 1,
          });
        }
      }
    );
  };
  imgLoadLog(data: Obj = {}) {
    const duration = Date.now() - this.start_time;
    const { challenge_mode, challenge_id, challenge_code } = this.props;
    logger.trackEvent('show_picture', {
      ...data,
      duration,
      mode: challenge_mode,
      challenge_id,
      challenge_code,
    });
  }
  render() {
    const {
      question_url,
      verify_status,
      loading,
      answer_url,
      drag_pos,
      mode,
      onMouseMove,
      verify_result_msg,
      show_verify_msg,
      challenge_code,
      challenge_id,
      challenge_mode,
      isFetch,
      imgLoadingBgColor,
      onStart,
      onDrag,
      onSubmit,
      slide_btn_able,
      drag_type,
      theme,
    } = this.props;
    const { loadAnswerFailed, loadQuestionFailed } = this.state;
    return (
      <div
        className="captcha_verify_img--wrapper"
        css={css`
          height: 1.72em;
          width: 2.76em;
          cursor: pointer;
          margin: 0 0.12em 0;
          box-sizing: border-box;
          position: relative;
          background: ${imgLoadingBgColor};
          overflow: hidden;
          border-radius: ${theme.imgBorderRadius};
        `}
        onMouseMove={onMouseMove} // 将图片的mousermove轨迹扩展到了整个验证码的轨迹
      >
        <TrackImage
          css={css`
            width: 100%;
            height: 100%;
          `}
          getRef={(el: any) => {
            this.$canvas = el!;
          }}
          loadQuestionFailed={loadQuestionFailed}
          scheduleStatus={this.scheduleStatus}
          src={question_url}
          challenge_id={challenge_id}
          challenge_mode={challenge_mode}
          challenge_code={challenge_code}
          alt=""
          onClick={this.handleCanvasClick}
          onError={this.imgErrorHandlerQuestion}
          onLoad={this.onImgLoad}
        />
        {mode === 'slide' && (
          <Draggable
            bounds={{
              left: 0,
              top: 0,
              right: (baseRem * scale * 220) / 100, // 276 - 52 - 2 * 2 = 220 左右各有 2px
              bottom: 0,
            }}
            key={question_url}
            axis="x"
            onStart={(e, d) => onStart(e, d, 'img')}
            onDrag={onDrag}
            onStop={onSubmit}
            disabled={!slide_btn_able}
          >
            {answer_url && (
              <img
                className="captcha_verify_img_slide"
                alt=""
                src={answer_url}
                css={css`
                  ${loadAnswerFailed ? 'display: none;' : ''}
                  position: absolute;
                  width: ${(scale * 55) / 100}em;
                  height: ${(scale * 55) / 100}em;
                `}
                onError={() => answer_url && this.imgErrorHandlerAnswer()}
                onLoad={() => this.onImgLoad('loadAnswerSuccess')}
                style={
                  drag_type == 'btn'
                    ? {
                        left: drag_pos.x,
                        top: `${(scale * drag_pos.y) / 100}em`, // NOTE: 大图拉伸 ---> 视觉对齐， 改变小 img 位置，和 w/h 55 ---> 60
                      }
                    : {
                        left: 0,
                        top: `${(scale * drag_pos.y) / 100}em`, // NOTE: 大图拉伸 ---> 视觉对齐， 改变小 img 位置，和 w/h 55 ---> 60
                      }
                }
              />
            )}
          </Draggable>
        )}
        {show_verify_msg && (
          <VerifyMessage
            isFetch={isFetch}
            loading={loading}
            status={verify_status}
            verify_result_msg={verify_result_msg}
          />
        )}
        <div id="verify-points">{this.renderPoints()}</div>
      </div>
    );
  }
}
export default withTheme(
  connect(mapState, mapDispatch as any)(VerifyImage) as any
);
